@if (bulkStore.currentStep() === 'pickIndicators') {
  <app-indicator-pick-list
    [setRule]="setRule()"
    [keepSelection]="true"></app-indicator-pick-list>
}

@if (bulkStore.currentStep() === 'pickCategories') {
  <app-category-pick-list
    [autoselectChildren]="bulkStore.selectedAction() === 'remove'"
    [keepSelection]="true"
    [showTargetControls]="false"></app-category-pick-list>
}

@if (bulkStore.currentStep() === 'pickCategory') {
  <app-category-tree
    (categorySelection)="selectCategory($event)"></app-category-tree>
}

@if (bulkStore.currentStep() === 'pickSet') {
  <app-indicator-set-pick-list
    [selectedSet]="bulkStore.set()"
    [disabledIds]="selectedSetIds()"
    (indicatorSelection)="selectSet($event)"></app-indicator-set-pick-list>
}

@if (bulkStore.currentStep() === 'pickTags') {
  <app-tag-pick-list [keepSelection]="true"></app-tag-pick-list>
}

@if (bulkStore.currentStep() === 'pickDataLayers') {
  <app-year-pick-list></app-year-pick-list>
}

@if (bulkStore.currentStep() === 'confirm') {
  <app-bulk-overview></app-bulk-overview>
}

<p-divider />
<footer class="flex flex-wrap gap-3">
  <p-button
    [rounded]="true"
    icon="fas fa-times"
    [outlined]="true"
    label="abbrechen"
    (click)="cancel()"
    severity="secondary"></p-button>

  @if (prevStep) {
    <p-button
      [rounded]="true"
      severity="secondary"
      icon="fas fa-arrow-left"
      [outlined]="true"
      label="zurück"
      (click)="backStep()"></p-button>
  }

  @if (bulkStore.currentStep() === 'pickIndicators') {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="Indikatoren auswählen"
      [disabled]="!indicatorStore.selection().length"
      (click)="selectIndicators()"></p-button>
  } @else if (bulkStore.currentStep() === 'pickTags') {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="Schlagworte auswählen"
      [disabled]="!tagStore.selection().length"
      (click)="selectTags()"></p-button>
  } @else if (bulkStore.currentStep() === 'pickCategory') {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="Ordner auswählen"
      [disabled]="!bulkStore.category()"
      (click)="nextStep()"></p-button>
  } @else if (bulkStore.currentStep() === 'pickSet') {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="Indikatorenset auswählen"
      [disabled]="!bulkStore.set()"
      (click)="nextStep()"></p-button>
  } @else if (bulkStore.currentStep() === 'pickDataLayers') {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="Jahre auswählen"
      [disabled]="!dataLayerStore.selection().length"
      (click)="selectYears()"></p-button>
  } @else if (bulkStore.currentStep() === 'pickCategories') {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="Ordner auswählen"
      [disabled]="!categoryStore.selection().length"
      (click)="selectCategories()"></p-button>
  } @else {
    <p-button
      [rounded]="true"
      class="ml-auto"
      icon="fas fa-check-circle"
      label="ausführen"
      (click)="confirmAction()"></p-button>
  }
</footer>
